import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

const SessionCountdown = ({ expiresAt }) => {
  SessionCountdown.propTypes = {
    expiresAt: PropTypes.number.isRequired,
  }

  const [timeLeft, setTimeLeft] = useState('')

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = Math.floor(Date.now() / 1000)
      const diff = expiresAt - now

      if (diff <= 0) {
        return 'Expired'
      }

      const minutes = Math.floor(diff / 60)
      const seconds = diff % 60

      return `${minutes}m ${seconds}s`
    }

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)

    setTimeLeft(calculateTimeLeft())

    return () => clearInterval(timer)
  }, [expiresAt])

  return <span>{timeLeft}</span>
}

export default SessionCountdown
